import { IEvent } from "../interfaces/models/IEvent";
import {
  formatFlexibleEventDateLabel,
  getEventDateDisplayMode,
  parseFlexibleEventMonthYear,
} from "./eventFlexibleDate";

export function formatEventSingleDate(timestamp: number): string {
  const date = new Date(timestamp * 1000);
  const day = date.getUTCDate();
  const month = date.toLocaleDateString("en-US", {
    month: "long",
    timeZone: "UTC",
  });
  const year = date.getUTCFullYear();
  return `${day} ${month} ${year}`;
}

export function formatEventDateRange(
  startTimestamp: number,
  endTimestamp?: number | null,
): string {
  if (!endTimestamp) {
    return formatEventSingleDate(startTimestamp);
  }

  const startDate = new Date(startTimestamp * 1000);
  const endDate = new Date(endTimestamp * 1000);
  const startDay = startDate.getUTCDate();
  const startMonth = startDate.toLocaleDateString("en-US", {
    month: "long",
    timeZone: "UTC",
  });
  const startYear = startDate.getUTCFullYear();
  const endDay = endDate.getUTCDate();
  const endMonth = endDate.toLocaleDateString("en-US", {
    month: "long",
    timeZone: "UTC",
  });
  const endYear = endDate.getUTCFullYear();

  const startDateUTC = new Date(
    Date.UTC(startYear, startDate.getUTCMonth(), startDay),
  );
  const endDateUTC = new Date(
    Date.UTC(endYear, endDate.getUTCMonth(), endDay),
  );

  if (startDateUTC.getTime() === endDateUTC.getTime()) {
    return formatEventSingleDate(startTimestamp);
  }

  if (startYear !== endYear) {
    return `${startDay} ${startMonth} ${startYear} - ${endDay} ${endMonth} ${endYear}`;
  }

  if (startMonth !== endMonth) {
    return `${startDay} ${startMonth} ${startYear} - ${endDay} ${endMonth} ${endYear}`;
  }

  return `${startDay} - ${endDay} ${startMonth} ${startYear}`;
}

export function formatEventDate(
  event: IEvent | null | undefined,
  shortDefaultDate?: boolean,
): string {
  if (!event) {
    return shortDefaultDate ? "TBD" : "Date To Be Determined";
  }

  const dateMode = getEventDateDisplayMode(event);
  if (dateMode === "monthYear") {
    return formatFlexibleEventDateLabel(
      event.comingSoonDateMessage,
      shortDefaultDate ? "TBD" : "Date To Be Determined",
    );
  }
  if (dateMode === "comingSoon") {
    const custom = String(event.comingSoonDateMessage ?? "").trim();
    if (custom && !parseFlexibleEventMonthYear(custom)) {
      return custom;
    }
    return shortDefaultDate ? "TBD" : "Date To Be Determined";
  }

  if (event.startDate === undefined || event.startDate === null) {
    return shortDefaultDate ? "TBD" : "Date To Be Determined";
  }

  if (event.endDate !== undefined && event.endDate !== null) {
    return formatEventDateRange(event.startDate, event.endDate);
  }

  return formatEventSingleDate(event.startDate);
}
